import "./SetupScreen.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import crossBlack from "../../../../assets/images/onboardingImages/crossBlack.svg";
import logo_black from "../../../../assets/images/onboardingImages/logo_black.svg";
import longArrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import Modal from "react-bootstrap/Modal";
import RocketImg from "../../../../assets/images/onboardingImages/rocket.gif";
import { useDispatch, useSelector } from "react-redux";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { getUserTradePermissionType } from "../../../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketContext";
import { useSetAtom } from "jotai";
import { paymentTypeAtom } from "../../../../store/globalstore";
import { resetOnBoardingStartContext } from "../../../../redux/users/usersSlice";

const SetupScreen = () => {
  const [show, setShow] = useState(true);
  const setPaymentType = useSetAtom(paymentTypeAtom);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext
  );
  const [buttonText, setButtonText] = useState("Launch Copy Trading Service");
  const navigate = useNavigate();
  const subscription = user?.verifiedmyTrade?.subscription;
  const hasActiveSubscription =
    subscription?.active && subscription.originalName;
  const isConnected =
    user?.binanceCredentials?.isConnected ||
    user?.bybitCredentials?.isConnected;
  const handleClose = () => {
    if (onBoardingStartContext) {
      setShow(false);
      dispatch(resetOnBoardingStartContext());
      navigate(onBoardingStartContext, { replace: true });
      return;
    }
    navigate(`/${user?.role}/dashboard`, { replace: true });
    setShow(false);
  };

  const handleOnboarding = () => {
    if (user?.role === "leader") {
      if (!user?.onboarding?.isCommunityCreated) {
        navigate("/leader/onboarding/community", { replace: true });
        return;
      }

      if (!user?.onboarding?.connect) {
        navigate("/leader/onboarding/connection", { replace: true });

        return;
      }

      if (!user?.onboarding?.subscribed) {
        const permissionType = getUserTradePermissionType(user);
        const needsSpotCoin =
          permissionType === "spot" || permissionType === "both";
        if (needsSpotCoin && !user?.spotQuotePreference) {
          navigate("/leader/onboarding/spotCoin", { replace: true });
          return;
        }
        navigate("/leader/onboarding/subscription");
        return;
      }

      if (!user?.onboarding?.payment) {
        navigate("/leader/onboarding/payout");
        return;
      }

      if (!user?.onboarding?.isVerified) {
        if (user?.socialLogin?.discord?.id || user?.socialLogin?.telegram?.id) {
          navigate("/leader/onboarding/importantUpdates", { replace: true });
        } else {
          navigate("/leader/onboarding/verify", { replace: true });
        }
        return;
      }
      navigate("/leader/onboarding/community");
    } else if (user?.role === "member") {
      if (!user?.onboarding?.payment) {
        navigate("/member/copyTrade");
        return;
      }

      if (!user?.onboarding?.connect) {
        navigate("/member/onboarding/connection");
        return;
      }

      navigate("/member/dashboard");
    }
  };

  useEffect(() => {
    if (user?.role === "leader") {
      const isOnBoardingComplete =
        user?.onboarding?.isCommunityCreated &&
        user?.onboarding?.connect &&
        user?.onboarding?.payment &&
        user?.onboarding?.subscribed &&
        user?.onboarding?.isVerified;

      if (user?.onboarding?.isCommunityCreated && !isOnBoardingComplete) {
        setButtonText("Start Copy Trade (Continue)");
      }

      if (isOnBoardingComplete) {
        setButtonText("Launch Extra Copy Trading Service");
      }
    } else if (user?.role === "member") {
      if (user?.onboarding?.payment) {
        setButtonText("Start Copy Trade (Continue)");
      }
    }
  }, [user]);

  const handleVerifyMyTrade = () => {
    navigate("/leader/verifymyTrade/tradeinfo", { replace: true });
  };

  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal setupScreen"
        show={show}
      >
        <Modal.Body>
          <button className="CrossIcon" onClick={handleClose} type="button">
            <img alt="" src={crossBlack} />
          </button>
          <div className="onboardingContentBox">
            <img src={RocketImg} alt="" className="rocketImg" />
            <p className="title">What do you want to do?</p>
            <p className="desc">Just takes a few clicks and you'll be set up</p>

            <BubbleSvgButton
              className="NextBtn"
              onClick={handleOnboarding}
              text={buttonText}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />
            <div>
              <BubbleSvgButton
                className="NextBtn"
                onClick={handleVerifyMyTrade}
                text={
                  user?.verifiedmyTrade.payment
                    ? "Verify Again"
                    : "Verify A Trade"
                }
                type="button"
                variant="black"
                containerStyling={{
                  justifyContent: "center",
                }}
                mainDivStyle={{
                  width: "275px",
                  height: "55px",
                }}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SetupScreen;
